import { useState } from 'react';
import { get } from 'lodash';
import GET_EXTERNAL_ISSUES_LOGS from '../../../queries/GET_EXTERNAL_ISSUES_LOGS';

export const useExternalIssuesLogs = (client) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchIssuesLogs = async (variables) => {
        console.log('testing');
        setLoading(true);

        const result = await client.query({
            query: GET_EXTERNAL_ISSUES_LOGS,
            variables,
            fetchPolicy: 'network-only'
        });

        setData(get(result, 'data.getExternalIssuesLogs'));
        setLoading(false);
    };

    return { issueLogs: data, loading, refetchIssueLogs: fetchIssuesLogs };
};
